import { render, staticRenderFns } from "./MsgErroModal.vue?vue&type=template&id=13c8ac8c&scoped=true&"
import script from "./MsgErroModal.vue?vue&type=script&lang=js&"
export * from "./MsgErroModal.vue?vue&type=script&lang=js&"
import style0 from "./MsgErroModal.vue?vue&type=style&index=0&id=13c8ac8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c8ac8c",
  null
  
)

export default component.exports